'use client';
import { createContext, useContext } from 'react';

const LocaleContext = createContext(undefined);

export function LocaleProvider({ locale, dict, children }) {
  const value = {
    locale,
    dir: locale === 'ar' ? 'rtl' : 'ltr',
    home: locale === 'ar' ? '/ar' : '/',
    t: dict,
  };
  return <LocaleContext.Provider data-component-id="src/i18n/LocaleContext.jsx:13:9" data-component-path="src/i18n/LocaleContext.jsx" data-component-line="13" data-component-file="LocaleContext.jsx" data-component-name="LocaleContext.Provider" data-component-content="%7B%22elementName%22%3A%22LocaleContext.Provider%22%2C%22value%22%3A%22%5Bvar%3Avalue%5D%22%7D" value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error('useLocale must be used inside <LocaleProvider>');
  return ctx;
}
